var ACTIVE_PARAMETER_SELECTOR = ".parameter-dependent:not(.no-display):not(.noDisplay):not(.default-variant)";
var SPLIT_SELECTOR = ".variant-list .hidden-split-parameter, .variant-list .split-parameter";

function getVariantDataMap() {
  return window.shoptet && shoptet.variantsSplit && shoptet.variantsSplit.necessaryVariantData ? shoptet.variantsSplit.necessaryVariantData : null;
}

function variantHasSale(variantKey) {
  var variantData = getVariantDataMap() && getVariantDataMap()[variantKey];
  if (!variantData) return false;

  var standardPrice = parseInt(String(variantData.standardPrice || "").replace(/\D/g, ""), 10);
  var finalPrice = parseInt(String(variantData.price || "").replace(/\D/g, ""), 10);
  return !isNaN(standardPrice) && !isNaN(finalPrice) && standardPrice > finalPrice;
}

function isVariantDisabled($variant) {
  return $variant.hasClass("disabled");
}

function buildCustomVariants() {
  if ($("#simple-variants").length || !$(".variant-list, .surcharge-list").length) return;

  $("body").addClass("hasVariants");

  $(
    ".variant-list select, .surcharge-list select," +
      ".variant-list div.hidden-split-parameter, .variant-list div.split-parameter," +
      ".surcharge-list div.hidden-split-parameter, .surcharge-list div.split-parameter",
  ).each(function () {
    // Parametry bez obrázků renderuje Shoptet jako <select>, parametry s obrázky
    // (typicky barva) jako <div class="hidden-split-parameter"> s radio buttony
    // (Shoptetův nativní "advanced-parameter" výběr) - potřebujeme umět obojí.
    var $control = $(this);
    var isSelect = $control.is("select");
    var parameterId = $control.data("parameter-id");
    var tooltip = $control.closest(".surcharge-list").find("th .show-tooltip").attr("title") || "";
    var isVariantList = $control.is('[name*="parameterValueId"]') || $control.find('[name*="parameterValueId"]').length > 0;
    var parameterName =
      $control.data("parameter-name") ||
      $.trim(
        $control
          .closest("tr")
          .find("th")
          .first()
          .clone()
          .find(".show-tooltip")
          .remove()
          .end()
          .text(),
      );
    var parameterSlug = parameterName
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
    // Obrázkový parametr poznáme podle typu ovládacího prvku, ne podle názvu -
    // parametrů s obrázky může být víc a nemusí se jmenovat "barva" (např. "barva 2", "Podstava").
    var hasImages = isVariantList && !isSelect;
    var html =
      '<div class="custom-variant ' +
      parameterSlug +
      (hasImages ? " hasImages" : "") +
      '" data-groupId="' +
      parameterId +
      '"><div class="tms">' +
      parameterName +
      ':</div><div class="custom-variant-wrap ' +
      parameterSlug +
      '" data-param-id="' +
      parameterId +
      '">';

    var $options = isSelect ? $control.find("option") : $control.find("label.advanced-parameter");

    $options.each(function () {
      var $option = $(this);
      var value, label;

      if (isSelect) {
        value = $option.attr("value");
        label = $option.text();
      } else {
        value = $option.find('input[type="radio"]').attr("value");
        label =
          $.trim($option.find(".parameter-value").text()) ||
          $option.find(".advanced-parameter-inner").attr("title") ||
          $option.find("img").attr("alt") ||
          "";
      }

      if (!$.isNumeric(value)) return;

      if (isVariantList) {
        var parts = label.split("+");
        html += '<div class="variant haveVariant" data-value="' + value + '" data-parameter-id="' + parameterId + '" data-param-val="' + parameterId + "-" + value + '"><div class="text"><span class="label">' + $.trim(parts[0]) + "</span>";
        if (tooltip && parts[1] !== "0 Kč") {
          html += '<span class="show-tooltip question-tooltip" title="' + tooltip + '">?</span>';
        }
        html += "</div></div>";
        return;
      }

      html += '<div class="variant haveSurcharge show-tooltip" title="' + label + '" data-value="' + value + '" data-parameter-id="' + parameterId + '" data-param-val="' + parameterId + "-" + value + '"><div class="image"><img src="/user/documents/upload/obrazky/detail/priplatky/' + value + ".svg?v=" + new Date().getMinutes() + '" alt="' + label + '"></div></div>';
    });

    html += "</div></div>";
    $control.after(html).hide();
    $control.closest(".variant-list span, .surcharge-list span").hide();
  });
}

function initBarvaVariantSlider() {
  $(".custom-variant.hasImages .custom-variant-wrap").each(function () {
    var $wrap = $(this);

    if ($wrap.hasClass("slick-initialized")) {
      $wrap.slick("setPosition");
      return;
    }

    // Shoptet dohydratuje stránku asynchronně - dokud wrap nemá reálnou šířku
    // (skrytý/ještě nepřipojený layout), slick spočítá track na fantasmagorickou
    // šířku a .detail-parameters vyteče. Init proto zkoušíme opakovaně, dokud
    // není wrap vidět a nemá šířku.
    if (!$wrap.is(":visible") || !$wrap.width()) return;
    $wrap.slick({
      slidesToShow: 7,
      slidesToScroll: 3,
      arrows: true,
      dots: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 4,
          },
        },

      ]
    });
  });
}

function attachVariantMetadata() {
  var map = getVariantDataMap();
  if (!map) return;

  Object.keys(map).forEach(function (key) {
    var variant = map[key];
    var availability = variant.availabilityName
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/ /g, "-");
    $('.custom-variant-wrap .variant[data-param-val="' + key + '"]')
      .addClass("haveImage")
      .attr("data-price-id", variant.id)
      .attr("data-avail", availability)
      .toggleClass("disabled", availability === "Momentalne-nedostupne")
      .attr("data-sale", variantHasSale(key));
  });
}

var VARIANTS_API_URL = "https://shoptetapi.shopcode.cz/public/api.php";
var VARIANTS_API_KEY = "fb2978bc263cde095c6aaae887b50d00";

function getVariantApiCode() {
  var map = getVariantDataMap() || {};
  for (var key in map) {
    if (map[key].code) return map[key].code;
  }
  return null; // produkt bez variant
}

var $activeVariantSwatch = null;

function initVariantSwatchColorbox($swatches) {
  if (!$.fn.colorbox) return false;

  $swatches.colorbox({
    close: "Zavřít",
    width: function () {
      return $(window).width() >= 768 ? "600px" : "90%";
    },
    height: function () {
      return $(window).width() >= 768 ? "660px" : "auto";
    },
    maxWidth: "90%",
    maxHeight: "90%",
    html: function () {
      $activeVariantSwatch = $(this);
      var title = $activeVariantSwatch.attr("title") || "";

      return (
        '<div class="variant-popup">' +
        '<img class="variant-popup-image" src="' +
        $activeVariantSwatch.data("href") +
        '" alt="' +
        title +
        '">' +
        '<span class="tms">' +
        title +
        "</span>" +
        '<button type="button" class="btn btn-primary variant-popup-select">Vybrat variantu</button>' +
        "</div>"
      );
    },
    onComplete: function () {
      // Keep the variant popup and its close button visible outside the box.
      var colorboxStyle = document.getElementById("colorbox").style;
      this.variantPopupOverflow = {
        value: colorboxStyle.getPropertyValue("overflow"),
        priority: colorboxStyle.getPropertyPriority("overflow"),
      };
      colorboxStyle.setProperty("overflow", "visible", "important");

      // Na desktopu je výška pevná (660px), není co dopočítávat.
      if ($(window).width() >= 768) return;

      // Measure again after image load, without the CSS max-height: 100%
      // constraint that would retain the initial, collapsed popup height.
      var $loaded = $("#cboxLoadedContent");
      var $popup = $loaded.find(".variant-popup");
      var $img = $popup.find(".variant-popup-image");
      if (!$img.length) return;

      var resize = function () {
        if (!$.colorbox || $(window).width() >= 768 ||
            !$.contains(document.documentElement, $popup[0])) return;

        // Remove the percentage constraint while measuring natural content height.
        var style = $popup[0].style;
        var previousHeight = style.height;
        var previousMaxHeight = style.maxHeight;
        $popup.css({ height: "auto", maxHeight: "none" });
        var contentHeight = $popup.outerHeight(true);
        style.height = previousHeight;
        style.maxHeight = previousMaxHeight;

        var paddingAndBorders = $loaded.outerHeight() - $loaded.height();
        var frameHeight = Math.max(0, $("#colorbox").outerHeight() - $loaded.height());
        var maxInnerHeight = Math.max(1, Math.floor($(window).height() * 0.9 - frameHeight));
        $.colorbox.resize({ innerHeight: Math.min(Math.ceil(contentHeight + paddingAndBorders), maxInnerHeight) });
      };

      $img.one("load.variantPopup error.variantPopup", resize);
      resize();
      $(window).off("resize.variantPopup").on("resize.variantPopup", resize);
    },
    onCleanup: function () {
      var colorbox = document.getElementById("colorbox");
      if (colorbox && this.variantPopupOverflow) {
        colorbox.style.setProperty("overflow", this.variantPopupOverflow.value, this.variantPopupOverflow.priority);
        delete this.variantPopupOverflow;
      }
      $(window).off("resize.variantPopup");
      $("#cboxLoadedContent .variant-popup-image").off(".variantPopup");
    },
  });
  return true;
}

function loadVariantSwatches() {
  if (!$(".custom-variant-wrap").length) return;

  $(".custom-variant.hasImages .custom-variant-wrap .variant").addClass("noImageNoColor");

  var query = { klic: VARIANTS_API_KEY };
  var code = getVariantApiCode();
  if (code) query.kod = code;
  else query.url = window.location.pathname;

  $.getJSON(VARIANTS_API_URL, query, function (data) {
    if (!data || !data.nalezeno) return;

    var $swatches = $();

    $.each(data.vzorky, function (i, v) {
      if (!v.id_hodnoty || (!v.obrazek && !v.barva)) return;

      var $vzorek = $('<span class="vzorek">').attr("title", v.popis);
      var $variant = $('.custom-variant-wrap .variant[data-value="' + v.id_hodnoty + '"]');

      if (v.obrazek) {
        $vzorek.css("background-image", "url(" + v.obrazek.maly+'?v='+new Date().getMinutes() + ")");
        if (v.obrazek.velky+'?v='+new Date().getMinutes()) $vzorek.addClass("hasPopup").attr("data-href", v.obrazek.velky+'?v='+new Date().getMinutes());
      } else {
        $vzorek.css("background-color", v.barva);
      }
      $variant.removeClass("noImageNoColor");

      $variant.find(".text").prepend($vzorek);
      $swatches = $swatches.add($vzorek);
    });

    var $withPopup = $swatches.filter("[data-href]");
    if (!$withPopup.length) return;

    if (!initVariantSwatchColorbox($withPopup)) {
      var interval = setInterval(function () {
        if (initVariantSwatchColorbox($withPopup)) clearInterval(interval);
      }, 500);
    }
  })
    .done(initBarvaVariantSlider)
    .fail(function () {
      /* 404 = produkt ještě neznáme */
    });
}

function findVariantControl(parameterId) {
  return $(
    'select[data-parameter-id="' + parameterId + '"], ' +
      'div.hidden-split-parameter[data-parameter-id="' + parameterId + '"], ' +
      'div.split-parameter[data-parameter-id="' + parameterId + '"]',
  );
}

function updateUnavailableVariants() {
  $(".custom-variant-wrap .variant").each(function () {
    var $variant = $(this);
    var parameterId = $variant.data("parameter-id");
    var value = $variant.data("value");
    var $control = findVariantControl(parameterId);
    // U <select> visí "unavailable-option" přímo na <option>, u radio-buttonového
    // (advanced-parameter) výběru ji Shoptet dává na obalující <label>.
    var unavailable = $control.is("select")
      ? $control.find("option[value='" + value + "']").hasClass("unavailable-option")
      : $control.find('input[value="' + value + '"]').parent().hasClass("unavailable-option");

    $variant.toggleClass("unavailable", unavailable);
    if (unavailable) $variant.removeClass("active");
  });
}

function updateCustomCartSaleState() {
  var hasSale =
    $(".custom-variant-wrap .variant.active").filter(function () {
      return $(this).attr("data-sale") === "true";
    }).length > 0;
  $(".customCart").toggleClass("sale", hasSale);
}

function updateAvailabilityDeliveryNote() {
  var $availability = $(".availability-value");
  if (!$availability.length) return;

  $availability.find(".delivery-time-note").remove();

  var $activeAvailability = $availability.find(ACTIVE_PARAMETER_SELECTOR).first();
  var availabilityText = $.trim($activeAvailability.find(".availability-label").text()).toLowerCase();
  var deliveryText = $.trim($(".delivery-time").find(ACTIVE_PARAMETER_SELECTOR).first().text());
  var deliveryDate = typeof getDeliveryDateByAvailability === "function" ? getDeliveryDateByAvailability(availabilityText) : null;
  var formattedDate = deliveryDate && typeof formatDeliveryDate === "function" ? formatDeliveryDate(deliveryDate) : "";

  if (!formattedDate && (!deliveryText || deliveryText === "-")) return;

  var style = $activeAvailability.find(".availability-label").attr("style") || "";
  $('<span class="delivery-time-note">' + (formattedDate || deliveryText.replace(/\.\d{4}$/, "")) + " u Vás</span>")
    .attr("style", style)
    .appendTo($availability);
}

function updateCurrentVariantLabel() {
  $(".custom-variant").each(function () {
    var $customVariant = $(this);
    var $title = $customVariant.find(".tms").first();
    if (!$title.length) return;

    var base = $title.attr("data-base-label") || $.trim($title.clone().children(".current").remove().end().text());
    var current = $.trim($customVariant.find(".variant.active .label").first().text());

    $title.attr("data-base-label", base).html(base);
    if (current) $title.append('<span class="current">' + current + "</span>");
  });
}

function refreshVariantUi() {
  updateUnavailableVariants();
  updateCustomCartSaleState();
  updateAvailabilityDeliveryNote();
  updateCurrentVariantLabel();
}

function setInitialActiveVariant() {
  $(".custom-variant-wrap").each(function () {
    var $variants = $(this).find(".variant");
    if ($variants.length === 1 && !isVariantDisabled($variants.first())) $variants.addClass("active");
  });

  var valueFromUrl = new URLSearchParams(window.location.search).get("parameterValueId");
  if (valueFromUrl) {
    $("div.variant[data-value='" + valueFromUrl + "']")
      .not(".disabled")
      .addClass("active");
  }
}

buildCustomVariants();
attachVariantMetadata();
initBarvaVariantSlider();
loadVariantSwatches();

$(document).ready(initBarvaVariantSlider);
document.addEventListener("ShoptetDOMContentLoaded", initBarvaVariantSlider);
document.addEventListener("ShoptetDOMPageContentLoaded", initBarvaVariantSlider);
document.addEventListener("ShoptetSurchargesPriceUpdated", initBarvaVariantSlider);
document.addEventListener("ShoptetSplitVariantParameterChange", initBarvaVariantSlider);

function selectVariant($variant) {
  if (isVariantDisabled($variant)) return;

  var parameterId = $variant.data("parameter-id");
  var value = $variant.data("value");
  var $control = findVariantControl(parameterId);

  if ($control.is("select")) {
    $control
      .find("option[value='" + value + "']")
      .prop("selected", true)
      .change();
  } else {
    $control
      .find('input[type="radio"][value="' + value + '"]')
      .prop("checked", true)
      .change();
  }

  $variant
    .closest('.custom-variant-wrap[data-param-id="' + parameterId + '"]')
    .find(".variant")
    .removeClass("active");
  $variant.addClass("active");

  $(SPLIT_SELECTOR).trigger("change");
  if ($control[0]) $control[0].dispatchEvent(new Event("change"));

  refreshVariantUi();
}

$(document).on("click", ".custom-variant-wrap .variant", function () {
  var $variant = $(this);
  // Obrázková varianta se vzorkem s popup obrázkem se nevybírá kliknutím na dlaždici -
  // otevře se jen náhled a vybrat jde pouze přes tlačítko "Vybrat variantu" v popupu.
  if ($variant.find(".vzorek.hasPopup").length) return;

  selectVariant($variant);
});

$(document).on("click", "#jsUnavailableCombinationMessage a", function () {
  $(".custom-variant-wrap .variant").removeClass("unavailable");
});

$(document).on("click", ".variant-popup-select", function () {
  if ($activeVariantSwatch && $activeVariantSwatch.length) {
    selectVariant($activeVariantSwatch.closest(".variant"));
  }
  if ($.colorbox) $.colorbox.close();
});

$(document).ready(function () {
  setInitialActiveVariant();
  refreshVariantUi();
});
